"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.CountrySelect = void 0;
var _countryCodesList = _interopRequireDefault(require("country-codes-list"));
var _react = _interopRequireWildcard(require("react"));
var _reactCircleFlags = require("react-circle-flags");
var _reactSelect = _interopRequireWildcard(require("react-select"));
var _Icon = require("../../Elements/Icon/Icon");
var _Spinner = _interopRequireDefault(require("../../Components/Spinner/Spinner"));
var _constants = require("../../utils/constants");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable react/jsx-props-no-spreading */

/* Generate the placeholder with image/flag placeholer */const ImagePlaceholder = props => {
  var _props$selectProps, _props$selectProps2, _props$selectProps3;
  const {
    children
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactSelect.components.Placeholder, {
    ...props,
    className: "ccl__select-input__select__placeholder--has-icon",
    children: [!(props != null && (_props$selectProps = props.selectProps) != null && _props$selectProps.menuIsOpen) && (props == null || (_props$selectProps2 = props.selectProps) == null ? void 0 : _props$selectProps2.codeSelect) && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      children: "?"
    }), !(props != null && (_props$selectProps3 = props.selectProps) != null && _props$selectProps3.menuIsOpen) && children]
  });
};
/* Chevron arrow */
const ChevronDown = props => {
  const {
    isDisabled
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
    color: isDisabled ? 'disabled' : 'interactive',
    type: "expand-more"
  });
};
/* Dropdown Indicator */
const DropdownIndicator = props => {
  const {
    isDisabled
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactSelect.components.DropdownIndicator, {
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ChevronDown, {
      isDisabled: isDisabled
    })
  });
};
DropdownIndicator.defaultProps = {
  isDisabled: false
};

/* Generate the options list with flags  */
const {
  SingleValue,
  Option
} = _reactSelect.components;
const ImageOption = props => {
  const {
    data
  } = props;
  const {
    callingCode,
    label,
    value,
    src,
    disabled,
    countryFlagCdnUrl = null
  } = data;
  const OptionIcon = () => {
    if (src) return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "image-icon",
      style: {
        backgroundImage: `url(${src})`
      }
    });
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactCircleFlags.CircleFlag, {
      countryCode: value.toLowerCase(),
      height: "24",
      style: {
        paddingRight: '12px'
      },
      cdnUrl: countryFlagCdnUrl
    });
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(Option, {
      ...props,
      isDisabled: disabled,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "option-country-flag",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(OptionIcon, {})
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "option-country-name",
        children: label
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "option-country-code",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: "option-quote",
          children: "("
        }), value.toUpperCase(), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: "option-quote",
          children: ")"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "option-country-numberic",
        children: `+${callingCode}`
      })]
    })
  });
};
/* Generate the selected value with icon  */
const ImageValue = props => {
  var _props$selectProps4;
  const {
    data
  } = props;
  const {
    callingCode,
    label,
    value,
    src
  } = data;
  const OptionIcon = () => {
    if (src) return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "image-icon",
      style: {
        backgroundImage: `url(${src})`
      }
    });
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactCircleFlags.CircleFlag, {
      countryCode: value.toLowerCase(),
      height: "24",
      style: {
        paddingRight: '12px'
      }
    });
  };
  if (props != null && (_props$selectProps4 = props.selectProps) != null && _props$selectProps4.menuIsOpen) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(SingleValue, {
      ...props,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "option-country-flag option-results"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "option-country-name option-results"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "option-country-code option-results"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "option-country-numberic option-results"
      })]
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(SingleValue, {
    ...props,
    isDisabled: true,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "option-country-flag option-results",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(OptionIcon, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "option-country-name option-results",
      children: label
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "option-country-code option-results",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "option-quote",
        children: "("
      }), value.toUpperCase(), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "option-quote",
        children: ")"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "option-country-numberic option-results",
      children: [' ', '+' + callingCode]
    })]
  });
};
/* Custom SPINNER  */
const CustomSpinner = props => {
  const {
    animation,
    size,
    variant
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Spinner.default, {
    animation: animation,
    size: size,
    variant: variant
  });
};
CustomSpinner.defaultProps = {
  animation: 'border',
  size: 'sm'
};
const cssComponentClass = 'ccl__form-input';
const cssTextClass = 'ccl__text';

/**
 * Primary UI component for form select fields
 */
const CountrySelect = ({
  customData,
  name,
  id,
  label,
  promptText,
  noOptionsMessage,
  hint,
  optionalText,
  error,
  errorMsg,
  disabled,
  lockCountry,
  isSearchable,
  srcImg,
  defaultValue,
  defaultLabel,
  lng,
  showName,
  showISO,
  showISDN,
  showFlag,
  showResultsName,
  showResultsISO,
  showResultsISDN,
  showResultsFlag,
  ShowAsCombobox,
  size,
  maxResults,
  onChange,
  onBlur,
  onFocus,
  setFocus,
  codeSelect,
  disabledCountryOption,
  visibleCountryOption,
  countryFlagCdnUrl,
  value: valueProp,
  ...props
}) => {
  const customComponents = {
    Placeholder: ImagePlaceholder,
    DropdownIndicator,
    Option: ImageOption,
    SingleValue: ImageValue,
    LoadingIndicator: CustomSpinner
  };
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  const [value, setValue] = (0, _react.useState)(defaultValue);
  const [options, setOptions] = (0, _react.useState)([]);

  // Updates the internal value state when the value prop changes
  (0, _react.useEffect)(() => {
    if (!valueProp) return;
    const matchingOption = options.find(option => option.value === valueProp.countryCode);
    if (!matchingOption) return;
    setValue(matchingOption.value);
  }, [valueProp]);
  (0, _react.useEffect)(() => {
    let shouldContinue = true;
    const fetchData = async () => {
      if (!customData && !lockCountry) {
        try {
          var _json$data;
          setIsLoading(true);
          const response = await fetch(`${_constants.SEARCH_URI}?lng=${lng}`);
          const json = await response.json();
          if (!shouldContinue) return;
          const {
            customList
          } = _countryCodesList.default;
          const formattedCountries = (_json$data = json.data) == null ? void 0 : _json$data.map(({
            countryCode,
            countryName,
            isoNumeric,
            languages
          }) => ({
            callingCode: customList('countryCode', '{countryCallingCode}')[countryCode],
            countryCode,
            countryName,
            isoNumeric,
            lng: languages,
            label: countryName,
            value: countryCode,
            disabled: disabledCountryOption ? disabledCountryOption.includes(countryCode) : false,
            visible: visibleCountryOption ? visibleCountryOption.includes(countryCode) : true,
            countryFlagCdnUrl: countryFlagCdnUrl
          })).sort((countryA, countryB) => countryA.countryName.localeCompare(countryB.countryName));
          setOptions(formattedCountries);
          setIsLoading(false);
          const defaultValueOrValueProp = defaultValue || (valueProp == null ? void 0 : valueProp.countryCode);
          const foundCountry = formattedCountries.find(countryEntry => countryEntry.value === defaultValueOrValueProp);
          if (defaultValueOrValueProp && foundCountry && !formattedCountries.disabled) {
            onChange(name, foundCountry.value, {
              ...foundCountry
            });
          }
        } catch (error) {
          console.error('Error fetching data:', error);
        } finally {
          setIsLoading(false);
        }
      }
    };
    fetchData();
    return () => {
      shouldContinue = false;
    };
  }, [customData, lng, lockCountry]);
  const handleChange = v => {
    if (!v.disabled) {
      setValue(v.value);
      onChange(name, v.value,
      // include all information associated with selected country
      {
        ...v
      });
    }
  };
  const handleBlur = () => {
    onBlur(name, true);
  };
  const selectRef = (0, _react.useRef)(null);
  const finalOptions = customData && customData.length > 0 ? customData : options.filter(d => d.visible === true);
  (0, _react.useEffect)(() => {
    if (setFocus) selectRef.current.focus();
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: [cssComponentClass, `${cssComponentClass}--is-form-input`, showFlag ? `${cssComponentClass}--has-icon` : '', showName ? `${cssComponentClass}--has-name` : '', showISDN ? `${cssComponentClass}--has-isdn` : '', showISO ? `${cssComponentClass}--has-iso` : '', codeSelect ? `${cssComponentClass}--code-select` : '', showResultsFlag ? `${cssComponentClass}--has-icon-results` : '', showResultsName ? `${cssComponentClass}--has-name-results` : '', showResultsISDN ? `${cssComponentClass}--has-isdn-results` : '', showResultsISO ? `${cssComponentClass}--has-iso-results` : '', size == 'large' ? `${cssComponentClass}--country-large` : `${cssComponentClass}--country-small`, !showResultsName && !showResultsISDN && showResultsISO || !showResultsName && showResultsISDN && !showResultsISO ? `${cssComponentClass}--has-only` : '', error ? `${cssComponentClass}--has-error` : '', disabled && !lockCountry ? `${cssComponentClass}--is-disabled` : ''].join(' '),
    ...props,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
      className: `${cssComponentClass}__label ${cssTextClass} ${cssTextClass}--body-text-bold`,
      htmlFor: id || name,
      children: [label, optionalText && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: `${cssComponentClass}__label__optional ${cssTextClass} ${cssTextClass}--small-body-text-italic`,
        children: `(${optionalText})`
      })]
    }), hint && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: `${cssComponentClass}__hint ${cssTextClass} ${cssTextClass}--informative-text`,
      children: hint
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactSelect.default, {
      className: `ccl__select-input-country ccl__select-input ccl__select-input${isSearchable ? '__combobox' : '__dropdown'}
                ${error ? 'ccl__select-input__select--has-error' : ''}`,
      classNamePrefix: "ccl__select-input__select",
      components: customComponents,
      codeSelect: codeSelect,
      placeholder: promptText
      // include calling code in filter if calling code is displayed
      ,
      filterOption: showISO ? (0, _reactSelect.createFilter)({
        stringify: option => `${option.value} ${option.label} ${option.data.callingCode}`
      }) : undefined,
      isDisabled: disabled || lockCountry,
      isLoading: !customData && disabled && !lockCountry ? false : isLoading,
      isClearable: false,
      isRtl: false,
      isSearchable: isSearchable,
      minLength: 1,
      maxMenuHeight: maxResults * (size == 'large' ? 52 : 50),
      name: name,
      id: id || name,
      options: finalOptions,
      defaultValue: finalOptions.find(option => option.value === defaultValue),
      value: finalOptions.find(option => option.value === value),
      noOptionsMessage: () => noOptionsMessage,
      isOptionDisabled: option => {
        return option.disabled;
      },
      onChange: handleChange,
      onBlur: handleBlur,
      onFocus: onFocus,
      ref: selectRef
    }), error && /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
      className: `${cssComponentClass}__error-message ${cssTextClass} ${cssTextClass}--error-small-text`,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        color: "error",
        type: "error",
        size: "xs"
      }), errorMsg]
    })]
  }, value);
};
exports.CountrySelect = CountrySelect;
CountrySelect.defaultProps = {
  customData: null,
  id: '',
  promptText: '',
  hint: '',
  optionalText: '',
  error: false,
  errorMsg: '',
  disabled: false,
  isSearchable: false,
  lng: 'en',
  showFlag: true,
  showResultsFlag: true,
  showName: true,
  showISO: true,
  showISDN: true,
  showResultsName: true,
  showResultsISO: true,
  showResultsISDN: true,
  defaultValue: '',
  defaultLabel: '',
  noOptionsMessage: 'No matching options',
  setFocus: false,
  codeSelect: false,
  countryFlagCdnUrl: '',
  onBlur: () => {},
  onChange: () => {}
};